import { BaseTextMergeContainerElement } from "./BaseTextMergeContainerElement";
import { TextMergeConfiguration } from "../TextMergeConfiguration";
import { ExpressionConfiguration } from "../../Expressions/ExpressionConfiguration";
import { BooleanDataDefinition } from "../../Common/Data/Definitions/BooleanDataDefinition";
import { DataDefinition } from "../../Common/Data/DataDefinition";
import { StateManager } from "../../Common/StateManager";
import { ExecutionData } from "../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../Common/Testing/ITestingContext";

export class ConditionalElement extends BaseTextMergeContainerElement {
    readonly __type = "conditional";
    readonly name = "Conditional Element";
    readonly styleElement: boolean = false;
    readonly ordinal: number = 10;

    constructor(fieldName?: string) {
        super();

        this._condition = new ExpressionConfiguration();
        this._condition.executionResult = new BooleanDataDefinition();
        if (fieldName) this._condition.rootExpression.expressionRoot.variableName = fieldName;
    }

    private _condition: ExpressionConfiguration;

    get condition(): ExpressionConfiguration {
        this._condition.inputData = () => {
            if (!this.parent) return new DataDefinition();

            return this.parent.getInputData();
        };
        return this._condition;
    }

    set condition(value: ExpressionConfiguration) {
        this._condition.inputData = () => {
            return this.getInputData();
        };
        this._condition = value;

        StateManager.propertyChanged(this, "condition");
    }

    getStorageData(): object {
        let d = super.getStorageData();

        Reflect.set(d, "condition", this._condition.getStorageData());

        return d;
    }

    setStorageData(data: object) {
        super.setStorageData(data);
        this._condition.setStorageData(Reflect.get(data, "condition"));
    }

    output(data: ExecutionData, config: TextMergeConfiguration, testContext: ITestingContext | undefined): string {
        if (this._condition.run(data, testContext)) {
            return super.output(data, config, testContext);
        }
        return "";
    }

    canAdd(_config: TextMergeConfiguration): boolean {
        return true;
    }

    getHTMLTag(): string {
        return "";
    }
}
